'use client';

import { useEffect } from 'react';

export default function DevErrorFilter() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Browser Extension Errors herausfiltern
      const originalError = console.error;
      const originalWarn = console.warn;
      
      console.error = (...args) => {
        const message = args[0]?.toString() || '';
        if (
          message.includes('runtime.lastError') ||
          message.includes('message port closed') ||
          message.includes('content_script_bundle')
        ) {
          return; // Ignoriere Extension-Errors
        }
        originalError.apply(console, args);
      };

      console.warn = (...args) => {
        const message = args[0]?.toString() || '';
        if (
          message.includes('runtime.lastError') ||
          message.includes('Extension')
        ) {
          return; // Ignoriere Extension-Warnings
        }
        originalWarn.apply(console, args);
      };

      // Cleanup bei Component Unmount
      return () => {
        console.error = originalError;
        console.warn = originalWarn;
      };
    }
  }, []);

  return null; // Rendert nichts
}